import { Container, Grid, Typography, Box, Tooltip } from "@mui/material";
import React from "react";
import { NavLink, Route, Routes } from "react-router-dom";
import classes from "../Styles/about.module.css";
import CodeIcon from "@mui/icons-material/Code";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import VideogameAssetIcon from "@mui/icons-material/VideogameAsset";
import PersonalInformation from "../Components/PersonalInformation";
import CloseIcon from "@mui/icons-material/Close";
import ProfessionalInfo from "../Components/ProfessionalInfo";
import Hobbies from "../Components/Hobbies";
import { usePortfolio } from "../Context/Portfolio";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const AboutPage = () => {
  const { aboutBio, skills, certificates } = usePortfolio();
  // Build comment-block lines from data (single source of truth)
  const commentBlockLines = [
    ...aboutBio.map((line) => `// ${line}`),
    `// I am fully proficient in ${skills.map((s) => s.name.toUpperCase()).join(", ")}.`,
  ];

  return (
    <>
      <Container disableGutters maxWidth="xl" className={classes.about_body}>
        <Grid container className={classes.grid_container}>
          <Grid
            item
            xs={12}
            sx={{
              display: { xs: "block", md: "none" },
              pl: { xs: 3, md: 0 },
              pb: { xs: 3, md: 0 },
              pt: 3,
              textAlign: "center",
            }}
          >
            <Typography className={classes.about_text}>_about-me</Typography>
          </Grid>
          <Grid
            item
            className={classes.grid_item}
            sx={{ display: { xs: "none", md: "block" } }}
            md={0.6}
          >
            <NavLink
              style={({ isActive }) =>
                isActive ? { color: "#81A1C1" } : { color: "#607B96" }
              }
              to={`/about/professional-information`}
            >
              <Tooltip title="proffesional-info" placement="right-start">
                <Typography sx={{ pb: 2 }}>
                  <CodeIcon />
                </Typography>
              </Tooltip>
            </NavLink>
            <NavLink
              style={({ isActive }) =>
                isActive ? { color: "#81A1C1" } : { color: "#607B96" }
              }
              to={`/about/personal-information`}
            >
              <Tooltip title="personal-info" placement="right-start">
                <Typography sx={{ pb: 2 }}>
                  <LightbulbIcon />
                </Typography>
              </Tooltip>
            </NavLink>
            <NavLink
              style={({ isActive }) =>
                isActive ? { color: "#81A1C1" } : { color: "#607B96" }
              }
              to={`/about/hobbies`}
            >
              <Tooltip title="hobbies" placement="right-start">
                <Typography sx={{ pb: 2 }}>
                  <VideogameAssetIcon />
                </Typography>
              </Tooltip>
            </NavLink>
          </Grid>

          <Routes>
            <Route exact path="/" element={<PersonalInformation />} />
            <Route
              exact
              path="personal-information"
              element={<PersonalInformation />}
            />
            <Route
              exact
              path="professional-information"
              element={<ProfessionalInfo />}
            />
            <Route exact path="hobbies" element={<Hobbies />} />
          </Routes>
          <Grid
            item
            md={5}
            sx={{ borderRight: { xs: "none", md: "0.25px solid #1E2D3D" } }}
          >
            <Box
              sx={{
                overflowY: { xs: "visible", md: "scroll" },
                height: "100%",
              }}
              className={classes.about_overflow}
            >
              <Box
                sx={{
                  borderBottom: { xs: "none", md: "0.25px solid #1E2D3D" },
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <Typography
                    sx={{
                      color: "#607B96",
                      borderRight: "0.25px solid #1E2D3D",
                      fontSize: "16px",
                      display: { xs: "none", md: "block" },
                      fontFamily: "'Fira Code', monospace !important",
                      pt: 1.4,
                      pb: 1,
                      pl: 2,
                    }}
                  >
                    personal-info
                    <CloseIcon
                      sx={{ fontSize: "18px", pt: 0.4, pl: 4, pr: 2 }}
                    />
                  </Typography>
                  <Typography
                    sx={{
                      color: "#FFFFFF",

                      fontSize: "16px",
                      display: { xs: "block", md: "none" },
                      fontFamily: "'Fira Code', monospace !important",
                      pt: 5,
                      pb: 1,
                      pl: 2,
                    }}
                  >
                    {`// personal-info`}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: { xs: "none", md: "block" }, p: 2 }}>
                <Box>
                  {commentBlockLines.map((line, index) => (
                    <Typography
                      key={index}
                      component="div"
                      sx={{
                        display: "flex",
                        wordBreak: "break-word",
                        fontFamily: "'Fira Code', monospace !important",
                        lineHeight: "1.8",
                      }}
                    >
                      <span
                        className={classes.about_numbers}
                        style={{
                          paddingRight: index + 1 < 10 ? "20px" : "12px",
                          minWidth: index + 1 > 9 ? "28px" : undefined,
                          flexShrink: 0,
                        }}
                      >
                        {index + 1}
                      </span>
                      <span
                        className={classes.about_info}
                        style={{
                          whiteSpace: "pre-wrap",
                          overflowWrap: "break-word",
                        }}
                      >
                        {line}
                      </span>
                    </Typography>
                  ))}
                </Box>
              </Box>
              <Box sx={{ display: { xs: "block", md: "none" }, pt: 4, pb: 5 }}>
                <Typography className={classes.about_info_small}>
                  {aboutBio.join(" ")}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={4}>
            <Typography
              sx={{
                color: "#FFFFFF",

                fontSize: "16px",

                fontFamily: "'Fira Code', monospace !important",
                pt: 2,
                pb: 1,
                pl: 2,
              }}
            >
              {`// Certifications`}
            </Typography>
            <Box
              sx={{
                width: "100%",
                mt: 10,
              }}
            >
              <Carousel
                autoPlay={true}
                centerSlidePercentage={20}
                infiniteLoop={true}
                interval={3000}
                stopOnHover={true}
                swipeable={true}
                width="100%"
                transitionTime={2000}
                showIndicators={false}
                showThumbs={false}
              >
                {certificates.map((cert) => (
                  <div key={cert.id}>
                    <img
                      style={{ width: "100%", height: "300px" }}
                      src={cert.url}
                      alt={cert.alt}
                    />
                  </div>
                ))}
              </Carousel>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default AboutPage;
